import { Component, OnInit } from '@angular/core';
import { serviceURLService } from '../service/serviceURL';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { from } from 'rxjs';
@Component({
  selector: 'app-ecards-detail',
  templateUrl: './ecards-detail.component.html',
  styleUrls: ['./ecards-detail.component.css']
})
export class EcardsDetailComponent implements OnInit {
  intimate: any = {};
  loading: boolean = false;
  policyPart: boolean = true;
  editPolicyPart: boolean = false;
  renewPolicyPart: boolean = false;
  claimPart: boolean = false;
  data: any = {};
  error: any;
  policy: any;
  cardNumber: string;
  contractLimit:string;
  insured: string;
  gender: string;
  relation: string;
  sumInsured: string;
  company: string;
  email: string;
  mobile: string;
  employeeId: string;
  policyNumber: string;
  insurer: string;
  policyCoverType: string;
  maternity: string;
  roomRent: string;
  policyName: string;
  TPA_NAME: string;
  coPay: string;
  diseaseLimit: string;
  Age: string;
  policyHolder: string;
  insurerLogoDetails: Array<any> = [];
  ailment: string;
  private onDestroy$: Subject<void> = new Subject<void>();
  diseaseList : any =  ["Accelerated Hypertention","ACL tear","Acute Gastro entritis","Anal Fissure",
  "Appendix","Bronchitis","CA Breast","Carcinoma of any part","Cataract","Cerebrovascular attack","CHOLELITHIASIS","Chronic Kidney Disease","Coronary Artery Disease","CSOM",
  "Dengue","Deviated Nasal Septum","Diabetes Malitus","Enteric Fever","Fever","Fibroid Uterus","Fracture","Hemorrhoids","Inguinal Hernia","Ischemic heart disease","Lower Respiratory tracT Infection",
  "Malaria","Mayocardial Infarction","Osteoarthritis","Other","PIVD","Pneumonitis","Maternity/Pregnancy/Delivery","Renal Stone",
  "Road traffic accident","Seizure disorder","Tonsilittis","TRANSIENT ISCHAMIC ATTACK","Tuberclosis","Umblical Hernia","Upper Respiratory tracT infection","Urinary Tract Infection","Viral Fever"]
  hospitalName: any;
  hospitalCity: any;
  hospitalState: any;
  estimatedAmount: any;
  employeeName: any;
  errorMessage: string;
  intimateSuccessfull: boolean = false;
  intimateFailure: boolean = false;
  registrationNumber: string;
  regDate: any;
  dischargeDate: any;
  dob:string;
  csoName: string;
  isClietNFI: boolean = false;  
  insurerCode: string = "";
  insurerLogo: string = "";
  policyStartDate: string = "";
  policyEndDate: string = "";
  policyJoiningDate: string = "";
  constructor(private serviceURLService: serviceURLService) { }

  ngOnInit() {
    this.getCardByCardNumber();
  }

  getCardByCardNumber() {
    this.cardNumber = window.location.href.split('/')[4];
    var cardId = localStorage.getItem("cardId");
    this.loading = true;
    this.serviceURLService.getCardDetails(cardId).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      this.policy = successData.response.notifyPolicy;
      this.loading = false;
      for (var i = 0; i < this.policy.length; i++) {
        console.log(this.policy.length);
        this.cardNumber = this.policy[i].cardNumber ? this.policy[i].cardNumber : this.policy[i].cardNo ;
        this.insured = this.policy[i].Insured;
        this.gender = this.policy[i].Gender;
        this.relation = this.policy[i].Relation;
        this.sumInsured = this.policy[i].sumInsured?this.policy[i].sumInsured:this.policy[i]["Sum Insured"];
        this.company = this.policy[i].companyName;
        this.email = this.policy[i].email;
        this.mobile = this.policy[i].phoneNumber;
        this.employeeId = this.policy[i].empId;
        this.policyNumber = this.policy[i].policyNumber ? this.policy[i].policyNumber : this.policy[i].policyNo;
        this.insurer = this.policy[i].Insurer;
        this.policyCoverType = this.policy[i].policyCoverType ? this.policy[i].policyCoverType : 'NA';
        this.maternity = this.policy[i].Maternity;
        this.roomRent = this.policy[i].roomRent?this.policy[i].roomRent:this.policy[i]['Room Rent'];
        this.policyName = this.policy[i].policyName;
        this.TPA_NAME = this.policy[i].TPA_NAME; 
        this.Age = this.policy[i].Age;
        this.policyHolder = this.policy[i].policyHolder; 
        this.contractLimit = this.policy[i]["Contract Limit"];
        this.coPay = this.policy[i].coPay ? this.policy[i].coPay : "NA"; 
        this.diseaseLimit = this.policy[i].diseaseLimit ? this.policy[i].diseaseLimit : "NA";
        this.dob = this.policy[i].Dob ? this.policy[i].Dob : this.policy[i]['Date of Birth'];
        this.csoName = this.policy[i].csoName;
        this.insurerCode = this.policy[i].insurerCode;
        this.policyStartDate = this.policy[i].startdate?this.policy[i].startdate:"NA";
        this.policyEndDate = this.policy[i].endDate?this.policy[i].endDate:"NA";
        this.policyJoiningDate = this.policy[i].policyJoiningDate?this.policy[i].policyJoiningDate:"NA";
      }
      if((!!localStorage.getItem('pamClientId') && localStorage.getItem('pamClientId').toLowerCase() === "738113".toLowerCase())
        || (!! localStorage.getItem('companyName') && localStorage.getItem('companyName').toLowerCase().trim() === "National Foundation for India-CSOs".toLowerCase().trim())){
        this.isClietNFI = true;
      }
      this.getInsurerLogo();
      // this.loading = false;
      if(this.relation.toUpperCase()=='EMPLOYEE' || this.relation.toUpperCase()=='SELF'){
        console.log("for updateWalletEcard true");
         this.updateWalletEcard(cardId);

      }
    }, errorData => {
      this.error = errorData;
      console.log("no data");
    })
  }

  getInsurerLogo() {
    // this.loading = true;
    this.serviceURLService.getInsurerLogo().pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      this.insurerLogoDetails = successData.data.insurerDtos;
      this.insurerLogoDetails.forEach(element => {
        if (element?.code?.toLowerCase() === this.insurerCode.toLowerCase()) {
          this.insurerLogo = element.insurerLogo;
        }
      })
      // this.loading = false;
    }, errorData => {
      this.error = errorData;
      console.log("no data");
    })
  }
  
  submitIntimateDetails(){
    if(this.regDate){
      var newAdmissionDateTime = new Date(this.regDate);
      newAdmissionDateTime.setHours(this.regDate.getHours() + 5);
      newAdmissionDateTime.setMinutes(this.regDate.getMinutes() + 30);
    }
    if(this.dischargeDate) {
      var newDischargeDateTime = new Date(this.dischargeDate);
      newDischargeDateTime.setHours(this.dischargeDate.getHours() + 5);
      newDischargeDateTime.setMinutes(this.dischargeDate.getMinutes() + 30);
    }
    if(this.company == ""){
      this.company = "-"
    }
    this.employeeName = localStorage.getItem('name');
    this.loading = true;
    this.intimate = {
      "mobileNo": this.mobile,
      "corporateName": this.company, 
      "employeeName":this.employeeName,
      "employeeId":this.employeeId,
      "insurer":this.insurer,
      "policyNumber": this.policyNumber,
      "claimant": this.insured,
      "relationWithEmployee":this.relation,
      "cardNumber": this.cardNumber,
      "email" : this.email,
      "productType":"Group Health Insurance",
      "hospitalState":this.hospitalState,
      "hospitalCity":this.hospitalCity,
      "hospitalName":this.hospitalName,
      "estimatedAmount": this.estimatedAmount,
      "claimMode": "REIMBURSEMENT",
      "claimSource":"notify",
      "rm":"",
      "ailment": this.ailment,
      "admissionDate":(newAdmissionDateTime),
      "dischargeDate": (newDischargeDateTime),
      "status":"INTIMATED",
      "subStatus":"INTIMATED",
      "registerManually": false
    }
    this.serviceURLService.submitClaimIntimate(this.intimate).pipe(takeUntil(this.onDestroy$)).subscribe((successData:any) => {
      
      this.loading = false;
      
      this.errorMessage = successData.error;
      if(!successData.success){
        
        this.intimateFailure = true;
      }else{
        this.intimateSuccessfull = true; 
        this.registrationNumber = successData.data;
      }
    }, errorData => {
      console.log("Oops..!! there is some error");
      this.loading = false;
      if(errorData.error.status === 403){
        this.error = errorData.error.message;
      }else if(errorData.error.status === 400){ // temperory solution for registering same number handling 
        this.error = errorData.error.message + " Number is already registered.";
        this.intimateFailure = true;
      }
    })
  }

  updateWalletEcard(cardId){
    this.serviceURLService.updateWalletForPolicyView(cardId).subscribe((successData:any)=>{
      console.log("wallet for policy view updated successsfully");
    },errorData => {
      this.error = errorData;
      console.log("no data");
    })
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
    }
    

}
